import { InternalSelectTileKey } from '.';
export var createInternalSelectTileDriver = function (wrapper) {
    var base = wrapper.$("." + InternalSelectTileKey);
    return {
        selectTile: function () { return base.$('.tile-container').click(); },
        rendersContentByClassName: function (cn) { return base.$('.tile-container').$("." + cn).exists(); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map